import { Loader } from '@seen/react'
import { type JSX, lazy, Suspense } from 'react'

// Admin-only route (/practitioners), reached by explicit navigation. App.tsx's
// <Outlet /> already supplies Suspense + an ErrorBoundary; the local Suspense
// keeps this safe if it is ever mounted somewhere without one.
const PractitionerManagerPageImpl = lazy(() =>
  import('#src/pages/PractitionerManagerPageImpl.tsx').then((m) => ({
    default: m.PractitionerManagerPageImpl,
  }))
)

export function PractitionerManagerPage(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <PractitionerManagerPageImpl />
    </Suspense>
  )
}
